import React from "react";
import { connect } from "react-redux";
import LoginComponent from "../components/landing/Login/LoginComponent";
import { clearTokenId, getTokenId } from "../actions/tokenActions";
import { activeMenuItem } from "../actions/headerActions";
import { apiEnd } from "../actions/apiActions";
import { login } from "../constants/labels";

const LoginContainer = (props) => <LoginComponent {...props} />;

const mapStateToProps = (state) => {
  return {
    tokenId: state.auth.token,
    isLoading: state.isLoading[login],
    errorMessage: state.auth.error,
  };
};

export default connect(mapStateToProps, {
  clearTokenId,
  getTokenId,
  apiEnd,
  activeMenuItem,
})(LoginContainer);